import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SidebarHeaderProps = ComponentProps<'div'>;

const SidebarHeader = ({ className, ...props }: SidebarHeaderProps) => {
  return (
    <div
      data-slot="sidebar-header"
      data-sidebar="header"
      className={cn('flex flex-col gap-2 p-2', className)}
      {...props}
    />
  );
};

export default SidebarHeader;
